import React from "react";
import type { RfxListTab } from "../../types/rfx-list.type";
import { getPanelEmptyStateCopy } from "./panelTabAssertion";

export const PanelEmptyState = ({ tab }: { tab: RfxListTab }) => (
	<p className="text-sm text-gray-500" data-testid="panel-empty-copy">
		{getPanelEmptyStateCopy(tab)}
	</p>
);
